import { enqueueSnackbar } from 'notistack';
import Axios, { AxiosError, AxiosHeaders } from 'axios' 
import useAxiosHook, { Options, configure } from 'axios-hooks'
import { AxiosRequestConfig } from 'axios';
import { useMemo } from 'react';

export const API = Axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`
})

API.interceptors.request.use((config) => {
    const token = window.localStorage.getItem('@vcm-painel/token')

    if (token) {
        (config.headers as AxiosHeaders).set('Authorization', `Bearer ${token}`)
    }

    return config 
})

API.interceptors.response.use(success => success, (error: AxiosError<{ message?: string }>) => {
    if ([403, 409].includes(error.response?.status as number)) {
        enqueueSnackbar(error.response?.data.message || 'Erro interno! Entre em contato com o administrador do sistema', {
            variant: 'error'
        })
        
        return Promise.resolve(error)
    }

    if (error.response?.status === 401) {
        window?.localStorage?.removeItem('@vcm-painel/token')
        
        if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
            window.location.href = '/login'
        }
    }

    return Promise.reject(error)
})

configure({ axios: API, defaultOptions: {
  autoCancel: false
}})

export const useAPI = (params: string | AxiosRequestConfig, options?: Options) => { 
    const config: AxiosRequestConfig = useMemo(() => {
        let newConfig: AxiosRequestConfig = {}

        if (typeof params === "string") {
            newConfig.url = params
        } else {
            newConfig = {
                ...params,
            }
        }

        return {
            ...newConfig
        }
    }, [params])

    return useAxiosHook(config, options)
}